import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const FileBreadcrumb = ({ currentPath }) => {
  // Parse the path into segments
  const pathParts = currentPath ? currentPath.split('/').filter(Boolean) : [];
  
  // Generate breadcrumb items
  const breadcrumbItems = [
    { name: 'Home', path: '/' },
    ...pathParts.map((part, index) => {
      const path = `/${pathParts.slice(0, index + 1).join('/')}`;
      return {
        name: part,
        path: `/folder${path}`
      };
    })
  ];

  return (
    <Breadcrumb className="mb-3">
      {breadcrumbItems.map((item, index) => (
        <Breadcrumb.Item 
          key={index} 
          linkAs={Link} 
          linkProps={{ to: item.path }}
          active={index === breadcrumbItems.length - 1}
        >
          {item.name}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default FileBreadcrumb;
